import { BUSINESS_TOOL_SECTIONS, BUSINESS_TOOL_SUB_SECTIONS } from 'constants/businessTool';

import { equipmentSectionInitialValues, IEquipmentSection } from '../../Equipment/utils/form';

export const prefix =
  `${BUSINESS_TOOL_SECTIONS.BUSINESS_OPERATIONS}.${BUSINESS_TOOL_SUB_SECTIONS.BUSINESS_OPERATIONS.ASSETS}` as const;

export const ASSETS_NAMES = {
  DESCRIPTION: 'description',
  GROUPS: 'mainEquipment',
  PURCHASED_GROUPS: 'purchasedEquipment',
  RATIONALE_FOR_PURCHASING: 'rationaleForPurchasing',
} as const;

export interface IAssets {
  [ASSETS_NAMES.DESCRIPTION]: string;
  [ASSETS_NAMES.GROUPS]: IEquipmentSection[];
  [ASSETS_NAMES.PURCHASED_GROUPS]: IEquipmentSection[];
  [ASSETS_NAMES.RATIONALE_FOR_PURCHASING]: string;
}

export const assetsInitialValues = {
  [ASSETS_NAMES.DESCRIPTION]: '',
  [ASSETS_NAMES.GROUPS]: [equipmentSectionInitialValues],
  [ASSETS_NAMES.PURCHASED_GROUPS]: [equipmentSectionInitialValues],
  [ASSETS_NAMES.RATIONALE_FOR_PURCHASING]: '',
};

